<template>
  <div class="divider">
    <span class="blue"></span>
    <span class="white"></span>
    <span class="red"></span>
    <span class="white"></span>
    <span class="blue"></span>
  </div>
  <!-- </transition> -->
</template>

<script>
export default {
  name: "Divider",

  setup() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.divider {
    width: 100%;
    height: 24px;
    display: flex;
    justify-content: center;

    .blue {
        height: 100%;
        background-color: #00468B;
        width: 29.5%;
    }

    .white {
        height: 100%;
        background-color: white;
        width: 7.28125%;
    }

    .red {
        height: 100%;
        background-color: #F16924;
        width: 26.4375%;
    }
}
</style>
